import {
  Component,
  EventEmitter,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import {
  VAIconRegistryService,
  chevronUp,
  chevronDown,
  search,
  check,
} from "@va/core-library/icons";
@Component({
  selector: "app-pharma-analyst-tab-lineitem-search",
  templateUrl: "./pharma-analyst-tab-lineitem-search.component.html",
  styleUrls: ["./pharma-analyst-tab-lineitem-search.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PharmaAnalystTabLineitemSearchComponent {
  dpCallSubscriber: Subscription;
  lineOptions: { value: number; label: string }[] = [];
  @Output() cascaderValueChange = new EventEmitter<any>();
  ctag;
  options: any[] = [];
  filteredOptions: any[] = [];
  searchText;
  cascaderValues: any[] = [];
  isSelected: boolean;
  selectedValue: any = {};
  searchedValue;
  isOpen = false;
  constructor(
    private service: PharmaDataService,
    private route: ActivatedRoute,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([chevronDown, chevronUp, search, check]);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.ctag = params.get("cTagId"); // Extract the parameter 'ctag'
    });
    this.getLineItemData(this.ctag);
    this.service.selectedLineItem.subscribe((value) => {
      this.selectedValue = value;
      this.cascaderValues = [value];
      if (this.options) {
        this.options = this.options.map((option) => ({
          ...option,
          prefixIcon: undefined,
        }));
      }
    });
  }
  onOpenChange(isOpen: boolean): void {
    this.isOpen = isOpen;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.selectedValue) {
      if (!changes.selectedValue.currentValue.value) {
        if (this.options) {
          this.options = this.options.map((option) => ({
            ...option,
            prefixIcon: undefined,
          }));
          this.filteredOptions = this.options;
        }
      }
    }
  }

  getLineItemData(drugId: number): void {
    this.service.getDistributionPageLineItems(drugId).subscribe((resp: any) => {
      // Transform flat data into Cascader format
      this.options = resp.data.map((item) => ({
        label: item.name,
        value: item.dapparameterid,
        prefixIcon:
          this.selectedValue && this.selectedValue.value === item.dapparameterid
            ? "check"
            : undefined,
      }));
      this.filteredOptions = this.options;
    });
  }

  onOptionChange(value: any): void {
    this.service.selectedLineItem.next(value);
    this.cascaderValues = value;
    if (this.options) {
      this.options = this.options.map((option) => ({
        ...option,
        prefixIcon: option.value === value.value ? "check" : undefined,
      }));
      this.filteredOptions = this.options;
    }
  }
  handleInputChange(item) {
    this.filteredOptions = this.getFilteredOptions(item);
  }
  lineItemSearched(event) {
    this.searchedValue = event;
  }
  highlight(text: string): string {
    if (!this.searchedValue) {
      return text;
    }
    const regex = new RegExp(`(${this.searchedValue})`, "gi");
    return text.replace(regex, "<strong>$1</strong>");
  }
  getFilteredOptions(searchTerm) {
    this.searchText = searchTerm;
    const formattedSearchTerm = searchTerm && searchTerm.trim().toLowerCase();
    const formattedOptions = [];
    for (const option of this.options) {
      const formattedTargetTerm = option.label.trim().toLowerCase();
      if (formattedTargetTerm.includes(formattedSearchTerm)) {
        formattedOptions.push(option);
      }
    }
    return formattedOptions;
  }

  ngOnDestroy() {
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
  }
}
